module.exports = __webpack_public_path__ + "img/shop2.b85e9a3a.jpg";